/* Splendora storefront interactions: quick add, countdowns, tabs, routine finder, routine and bundle builders. */
(function () {
  'use strict';

  /* ---------- Toast ---------- */
  var toastEl;
  var toastTimer;
  function toast(title, detail, isError) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'sp-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.classList.toggle('sp-toast--error', !!isError);
    toastEl.innerHTML =
      '<svg class="sp-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><circle cx="12" cy="12" r="9"/>' +
      (isError ? '<path d="M12 8v5M12 16h.01"/>' : '<path d="M8 12.3l2.8 2.8L16.2 9.5"/>') +
      '</svg><div><strong></strong><span></span></div>';
    toastEl.querySelector('strong').textContent = title;
    toastEl.querySelector('span').textContent = detail || '';
    requestAnimationFrame(function () {
      toastEl.classList.add('is-visible');
    });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-visible');
    }, 3200);
  }
  window.SplendoraToast = toast;

  /* ---------- Money (uses the store's own money format, e.g. "€{{amount_with_comma_separator}}") ---------- */
  function formatMoney(cents, format) {
    var fmt = format || '€{{amount_with_comma_separator}}';
    function group(n, decimals, thousands, decimal) {
      var parts = (n / 100).toFixed(decimals).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (parts[1] ? decimal + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
      switch (key) {
        case 'amount_no_decimals': return group(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return group(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(cents, 2, "'", '.');
        default: return group(cents, 2, ',', '.');
      }
    });
  }

  /* ---------- Quick add ---------- */
  function sectionInner(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector || '.shopify-section');
    return el ? el.innerHTML : '';
  }

  /* Adds items ([{ id, quantity }]) and refreshes the cart drawer and bubble.
     Resolves true on success. toastTitle is shown when there is no cart drawer. */
  function addToCart(items, toastTitle) {
    var cartDrawer = document.querySelector('cart-drawer');
    var sections = cartDrawer ? ['cart-drawer', 'cart-icon-bubble'] : ['cart-icon-bubble'];

    return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (result) {
        var data = result.data;
        if (!result.ok || data.status) {
          toast('Could not add to bag', data.description || data.message || 'Please try again.', true);
          return false;
        }

        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          var item = data.items && data.items[0] ? data.items[0] : {};
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(Object.assign({}, item, { sections: data.sections }));
        } else {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble && data.sections && data.sections['cart-icon-bubble']) {
            bubble.innerHTML = sectionInner(data.sections['cart-icon-bubble']);
          }
          toast(toastTitle || 'Added to bag', 'Ready for checkout');
        }

        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'sp-quick-add', productVariantId: items[0] && items[0].id });
        }
        return true;
      })
      .catch(function () {
        toast('Could not add to bag', 'Check your connection and try again.', true);
        return false;
      });
  }

  function quickAdd(button) {
    var variantId = button.getAttribute('data-variant-id');
    var productUrl = button.getAttribute('data-product-url');

    // Products with options open the theme's quick-buy drawer instead.
    if (button.hasAttribute('data-choose-options')) {
      var qb = document.querySelector('quick-buy-drawer');
      if (qb && typeof qb.open === 'function' && productUrl) {
        qb.open(productUrl, button);
      } else if (productUrl) {
        window.location.href = productUrl;
      }
      return;
    }
    if (!variantId) return;

    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    var name = button.getAttribute('data-product-title') || 'Item';
    addToCart([{ id: Number(variantId), quantity: 1 }], name + ' added to bag').then(function () {
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-sp-add]');
    if (!button) return;
    event.preventDefault();
    quickAdd(button);
  });

  /* ---------- Product card photo gallery (arrows + dots) ---------- */
  document.addEventListener('click', function (event) {
    var nav = event.target.closest('[data-sp-slide]');
    if (!nav) return;
    event.preventDefault();
    var track = nav.parentElement.querySelector('[data-sp-track]');
    if (!track) return;
    var step = track.clientWidth * Number(nav.getAttribute('data-sp-slide'));
    var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    if (step > 0 && atEnd) {
      track.scrollTo({ left: 0, behavior: 'smooth' });
    } else if (step < 0 && track.scrollLeft <= 2) {
      track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
    } else {
      track.scrollBy({ left: step, behavior: 'smooth' });
    }
  });

  document.addEventListener(
    'scroll',
    function (event) {
      var track = event.target;
      if (!track.matches || !track.matches('[data-sp-track]')) return;
      var dots = track.parentElement.querySelectorAll('.sp-product__dots span');
      if (!dots.length) return;
      var index = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    },
    true
  );

  /* ---------- Countdown (visual only) ---------- */
  function nextWeekday(targetDay) {
    // targetDay: 0 = Sunday ... 1 = Monday
    var now = new Date();
    var end = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var diff = (targetDay - end.getDay() + 7) % 7 || 7;
    end.setDate(end.getDate() + diff);
    return end;
  }

  function initCountdown(el) {
    if (el.dataset.spReady) return;
    el.dataset.spReady = '1';
    var out = el.querySelector('[data-sp-countdown-value]') || el;
    var endAttr = el.getAttribute('data-end');
    var end = endAttr ? new Date(endAttr) : null;
    if (!end || isNaN(end.getTime()) || end <= new Date()) {
      end = nextWeekday(Number(el.getAttribute('data-reset-day') || 1));
    }
    function tick() {
      var ms = Math.max(0, end - new Date());
      if (ms === 0) end = nextWeekday(Number(el.getAttribute('data-reset-day') || 1));
      var d = Math.floor(ms / 86400000);
      var h = Math.floor((ms % 86400000) / 3600000);
      var m = Math.floor((ms % 3600000) / 60000);
      var s = Math.floor((ms % 60000) / 1000);
      out.textContent = d + 'd ' + h + 'h ' + m + 'm ' + (s < 10 ? '0' : '') + s + 's';
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- Tabs (bestsellers filter) ---------- */
  function initTabs(root) {
    if (root.dataset.spReady) return;
    root.dataset.spReady = '1';
    var tabs = root.querySelectorAll('[data-sp-tab]');
    var panels = root.querySelectorAll('[data-sp-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-sp-tab');
        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.hidden = p.getAttribute('data-sp-panel') !== key;
        });
      });
    });
  }

  /* ---------- Routine finder (tag-matched collection products) ---------- */
  function initFinder(root) {
    if (root.dataset.spReady) return;
    root.dataset.spReady = '1';
    var form = root.querySelector('[data-sp-finder-form]');
    var result = root.querySelector('[data-sp-finder-result]');
    var pool = Array.prototype.slice.call(root.querySelectorAll('[data-sp-finder-pool] > *'));
    var grid = root.querySelector('[data-sp-finder-grid]');
    var summary = root.querySelector('[data-sp-finder-summary]');
    var empty = root.querySelector('[data-sp-finder-empty]');
    var typeLink = root.querySelector('[data-sp-finder-type-link]');
    var concernLink = root.querySelector('[data-sp-finder-concern-link]');
    var count = Number(root.getAttribute('data-count') || 3);
    if (!form || !result || !grid) return;

    function setCollectionLink(link, answer, prefix) {
      if (!link) return;
      var url = answer && answer.getAttribute('data-sp-finder-url');
      link.hidden = !url;
      if (url) {
        link.href = url;
        link.textContent = prefix + answer.value;
      }
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var type = form.querySelector('input[name="sp-skin-type"]:checked');
      var concern = form.querySelector('input[name="sp-skin-concern"]:checked');
      var typeTag = type && type.getAttribute('data-sp-finder-tag');
      var concernTag = concern && concern.getAttribute('data-sp-finder-tag');
      var concernHandle = concern && concern.getAttribute('data-sp-finder-handle');
      if (summary) {
        summary.textContent =
          (type ? type.value : 'Your skin') + (concern ? ' · ' + concern.value : '');
      }
      setCollectionLink(typeLink, type, 'Shop ');
      setCollectionLink(concernLink, concern, 'Shop ');
      grid.innerHTML = '';
      var matches = pool.filter(function (card) {
        if (!typeTag || !concernTag || card.getAttribute('data-sp-finder-concern') !== concernHandle) return false;
        var tags = (card.getAttribute('data-sp-finder-tags') || '').split('|');
        var typeMatches = tags.indexOf(typeTag) !== -1;
        if (typeTag.indexOf('Skin: ') === 0) typeMatches = typeMatches || tags.indexOf('Skin: All Skin Types') !== -1;
        return typeMatches && tags.indexOf(concernTag) !== -1;
      });
      matches
        .slice(0, count)
        .forEach(function (card) {
          grid.appendChild(card.cloneNode(true));
        });
      if (empty) empty.hidden = matches.length > 0;
      result.hidden = false;
      result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });

    var reset = root.querySelector('[data-sp-finder-reset]');
    if (reset) {
      reset.addEventListener('click', function () {
        result.hidden = true;
        grid.innerHTML = '';
      });
    }
  }

  /* ---------- Routine builder (one product per step) ---------- */
  function initBuilder(root) {
    if (root.dataset.spReady) return;
    root.dataset.spReady = '1';
    var form = root.querySelector('[data-sp-builder-form]');
    var result = root.querySelector('[data-sp-builder-result]');
    var list = root.querySelector('[data-sp-builder-list]');
    var totalEl = root.querySelector('[data-sp-builder-total]');
    var addBtn = root.querySelector('[data-sp-builder-add]');
    var addLabel = root.querySelector('[data-sp-builder-add-label]');
    var eyebrow = root.querySelector('[data-sp-builder-eyebrow]');
    var dataEl = root.querySelector('[data-sp-builder-data]');
    if (!form || !result || !list || !dataEl) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var addLabelText = addLabel ? addLabel.textContent : '';
    var moneyFormat = root.getAttribute('data-money-format');
    function fmt(cents) {
      return formatMoney(cents, moneyFormat);
    }

    // Morning/evening presets for the step checkboxes.
    form.querySelectorAll('input[name="sp-time"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        var key = radio.value;
        form.querySelectorAll('input[name="sp-step"]').forEach(function (box) {
          box.checked = box.getAttribute('data-' + key) === 'true';
        });
      });
    });

    var picks = []; // [{ step, candidates, index }]

    // Products within budget, not already picked for an earlier step,
    // with the favourite ingredient's products first.
    function candidatesFor(step, budget, preferred, used) {
      var pool = step.products.filter(function (p) {
        return (!budget || p.price <= budget) && used.indexOf(p.pid) === -1;
      });
      if (preferred) {
        var hit = pool.filter(function (p) { return preferred.indexOf(p.pid) !== -1; });
        var rest = pool.filter(function (p) { return preferred.indexOf(p.pid) === -1; });
        pool = hit.concat(rest);
      }
      return pool;
    }

    function render() {
      list.innerHTML = '';
      var total = 0;
      var count = 0;
      picks.forEach(function (pick, i) {
        var li = document.createElement('li');
        var product = pick.candidates[pick.index];
        if (!product) {
          li.className = 'sp-builder__item sp-builder__item--empty';
          li.innerHTML = '<div><span class="sp-builder__step"></span><p>Nothing in this budget yet. <a></a></p></div>';
          li.querySelector('.sp-builder__step').textContent = 'Step ' + (i + 1) + ' · ' + pick.step.title;
          var a = li.querySelector('a');
          a.href = pick.step.url;
          a.textContent = 'Browse ' + pick.step.title;
          list.appendChild(li);
          return;
        }
        total += product.price;
        count += 1;
        li.className = 'sp-builder__item';
        li.innerHTML =
          '<a class="sp-builder__thumb" tabindex="-1" aria-hidden="true"><img alt="" loading="lazy" width="76" height="76"></a>' +
          '<div><span class="sp-builder__step"></span><a class="sp-builder__name"></a>' +
          '<div class="sp-builder__meta"><strong></strong>' +
          '<button type="button" class="sp-builder__swap"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M4 7h13l-3-3M20 17H7l3 3"/></svg>Swap</button></div></div>';
        li.querySelector('.sp-builder__step').textContent = 'Step ' + (i + 1) + ' · ' + pick.step.title;
        var thumb = li.querySelector('.sp-builder__thumb');
        thumb.href = product.url;
        var img = thumb.querySelector('img');
        if (product.img) img.src = product.img;
        else img.remove();
        var name = li.querySelector('.sp-builder__name');
        name.href = product.url;
        name.textContent = product.title + (product.variant ? ' – ' + product.variant : '');
        li.querySelector('strong').textContent = fmt(product.price);
        var swap = li.querySelector('.sp-builder__swap');
        swap.setAttribute('aria-label', 'Swap ' + pick.step.title + ' product');
        if (pick.candidates.length < 2) swap.disabled = true;
        swap.addEventListener('click', function () {
          pick.index = (pick.index + 1) % pick.candidates.length;
          render();
          var again = list.children[i] && list.children[i].querySelector('.sp-builder__swap');
          if (again) again.focus();
        });
        list.appendChild(li);
      });
      if (totalEl) totalEl.textContent = fmt(total);
      if (addBtn) addBtn.disabled = count === 0;
      if (addLabel) addLabel.textContent = addLabelText + (count ? ' (' + count + ')' : '');
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var time = form.querySelector('input[name="sp-time"]:checked');
      var budgetEl = form.querySelector('[name="sp-budget"]');
      var ingrEl = form.querySelector('[name="sp-ingredient"]');
      var budget = budgetEl && budgetEl.value ? Number(budgetEl.value) : 0;
      var preferred = ingrEl && ingrEl.value && data.ingredients ? data.ingredients[ingrEl.value] || [] : null;
      var chosen = Array.prototype.map.call(form.querySelectorAll('input[name="sp-step"]:checked'), function (box) {
        return box.value;
      });
      if (!chosen.length) {
        toast('Pick at least one step', 'Choose the steps you want in your routine.', true);
        return;
      }
      var used = [];
      picks = data.steps
        .filter(function (step) { return chosen.indexOf(step.id) !== -1; })
        .map(function (step) {
          var candidates = candidatesFor(step, budget, preferred, used);
          if (candidates[0]) used.push(candidates[0].pid);
          return { step: step, candidates: candidates, index: 0 };
        });
      if (eyebrow) {
        var bits = [time && time.value === 'pm' ? 'Evening routine' : 'Morning routine'];
        if (ingrEl && ingrEl.value) bits.push(ingrEl.options[ingrEl.selectedIndex].text);
        eyebrow.textContent = bits.join(' · ');
      }
      render();
      result.hidden = false;
      result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var items = picks
          .map(function (pick) { return pick.candidates[pick.index]; })
          .filter(Boolean)
          .map(function (p) { return { id: p.vid, quantity: 1 }; });
        if (!items.length) return;
        addBtn.classList.add('is-loading');
        addToCart(items, 'Routine added to bag').then(function () {
          addBtn.classList.remove('is-loading');
        });
      });
    }

    var reset = root.querySelector('[data-sp-builder-reset]');
    if (reset) {
      reset.addEventListener('click', function () {
        result.hidden = true;
        list.innerHTML = '';
        picks = [];
        form.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    }
  }

  /* ---------- Bundle builder (pick N, tiered savings shown; discount applied by Shopify) ---------- */
  function initBundle(root) {
    if (root.dataset.spReady) return;
    root.dataset.spReady = '1';
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-sp-bundle-item]'));
    var tray = root.querySelector('[data-sp-bundle-tray]');
    var picked = root.querySelector('[data-sp-bundle-picked]');
    var addBtn = root.querySelector('[data-sp-bundle-add]');
    if (!tray || !picked || !addBtn) return;
    var max = Number(root.getAttribute('data-max') || 10);
    var min = Number(root.getAttribute('data-min') || 3);
    var tiers = (root.getAttribute('data-tiers') || '')
      .split(',')
      .map(function (t) {
        var p = t.split(':');
        return { qty: Number(p[0]), pct: Number(p[1]) };
      })
      .filter(function (t) { return t.qty > 0; })
      .sort(function (a, b) { return a.qty - b.qty; });
    var top = tiers.length ? tiers[tiers.length - 1].qty : min;
    var moneyFormat = root.getAttribute('data-money-format');
    function fmt(cents) {
      return formatMoney(cents, moneyFormat);
    }
    var el = function (sel) { return root.querySelector(sel); };
    var selection = []; // list items (li elements), in pick order

    function tierFor(count) {
      var hit = null;
      tiers.forEach(function (t) { if (count >= t.qty) hit = t; });
      return hit;
    }

    function update() {
      var count = selection.length;
      var subtotal = selection.reduce(function (sum, li) { return sum + Number(li.getAttribute('data-price')); }, 0);
      var tier = tierFor(count);
      var save = tier ? Math.round((subtotal * tier.pct) / 100) : 0;
      var next = null;
      tiers.forEach(function (t) { if (!next && count < t.qty) next = t; });

      el('[data-sp-bundle-count]').textContent = count;
      el('[data-sp-bundle-bar]').style.width = Math.min(100, (count / top) * 100) + '%';
      var msg = el('[data-sp-bundle-msg]');
      if (count === 0) msg.textContent = 'Pick ' + min + ' or more products to start saving.';
      else if (next) msg.textContent = 'Add ' + (next.qty - count) + ' more to save ' + next.pct + '%' + (tier ? ' (now ' + tier.pct + '%)' : '') + '.';
      else msg.textContent = 'You unlocked ' + tier.pct + '% off. Nice bundle!';
      if (count >= max) msg.textContent += ' Bundle is full (' + max + ' items).';

      el('[data-sp-bundle-subtotal]').textContent = fmt(subtotal);
      var saveRow = el('.sp-bundle__save');
      saveRow.hidden = !tier;
      if (tier) {
        el('[data-sp-bundle-save-label]').textContent = 'Bundle savings (' + tier.pct + '%)';
        el('[data-sp-bundle-save]').textContent = '−' + fmt(save);
      }
      el('[data-sp-bundle-total]').textContent = fmt(subtotal - save);
      addBtn.disabled = count < min;

      picked.innerHTML = '';
      selection.forEach(function (li) {
        var row = document.createElement('li');
        row.className = 'sp-bundle__row';
        var src = li.getAttribute('data-img');
        row.innerHTML = (src ? '<img alt="" width="40" height="40">' : '<i class="sp-bundle__noimg"></i>') + '<span></span><b></b><button type="button" class="sp-bundle__remove">×</button>';
        if (src) row.querySelector('img').src = src;
        row.querySelector('span').textContent = li.getAttribute('data-title');
        row.querySelector('b').textContent = fmt(Number(li.getAttribute('data-price')));
        var rm = row.querySelector('button');
        rm.setAttribute('aria-label', 'Remove ' + li.getAttribute('data-title'));
        rm.addEventListener('click', function () { toggle(li); });
        picked.appendChild(row);
      });

      items.forEach(function (li) {
        var on = selection.indexOf(li) !== -1;
        li.classList.toggle('is-picked', on);
        var btn = li.querySelector('[data-sp-bundle-toggle]');
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.disabled = !on && count >= max;
      });
    }

    function toggle(li) {
      var i = selection.indexOf(li);
      if (i === -1) {
        if (selection.length >= max) return;
        selection.push(li);
      } else {
        selection.splice(i, 1);
      }
      update();
    }

    items.forEach(function (li) {
      var btn = li.querySelector('[data-sp-bundle-toggle]');
      if (btn) btn.addEventListener('click', function () { toggle(li); });
    });

    // Filters: routine step tabs + ingredient select.
    var step = '';
    var ingredient = '';
    var empty = root.querySelector('[data-sp-bundle-empty]');
    function filter() {
      var shown = 0;
      items.forEach(function (li) {
        var ok = (!step || li.getAttribute('data-step') === step) &&
          (!ingredient || (' ' + li.getAttribute('data-ingr') + ' ').indexOf(' ' + ingredient + ' ') !== -1);
        li.hidden = !ok;
        if (ok) shown += 1;
      });
      if (empty) empty.hidden = shown > 0;
    }
    root.querySelectorAll('[data-sp-bundle-step]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        step = tab.getAttribute('data-sp-bundle-step');
        root.querySelectorAll('[data-sp-bundle-step]').forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        filter();
      });
    });
    var select = root.querySelector('[data-sp-bundle-ingredient]');
    if (select) {
      select.addEventListener('change', function () {
        ingredient = select.value;
        filter();
      });
    }

    // Mobile: the tray is a bottom sheet that expands to show the picked items.
    var expand = root.querySelector('[data-sp-bundle-expand]');
    if (expand) {
      expand.addEventListener('click', function () {
        var open = !tray.classList.contains('is-open');
        tray.classList.toggle('is-open', open);
        expand.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    addBtn.addEventListener('click', function () {
      if (selection.length < min) return;
      var lines = selection.map(function (li) { return { id: Number(li.getAttribute('data-vid')), quantity: 1 }; });
      addBtn.classList.add('is-loading');
      addToCart(lines, 'Bundle added to bag').then(function (ok) {
        addBtn.classList.remove('is-loading');
        if (ok) {
          selection = [];
          tray.classList.remove('is-open');
          update();
        }
      });
    });

    update();
  }

  /* ---------- Boot (also re-runs inside the theme editor) ---------- */
  function boot(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-sp-countdown]').forEach(initCountdown);
    root.querySelectorAll('[data-sp-tabs]').forEach(initTabs);
    root.querySelectorAll('[data-sp-finder]').forEach(initFinder);
    root.querySelectorAll('[data-sp-builder]').forEach(initBuilder);
    root.querySelectorAll('[data-sp-bundle]').forEach(initBundle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  /* ---------- Related products fallback ----------
     Dawn's <product-recommendations> loads on scroll via IntersectionObserver.
     Make sure it still loads shortly after page load if that never fires. */
  window.addEventListener('load', function () {
    setTimeout(function () {
      document.querySelectorAll('product-recommendations.sp-related__recs').forEach(function (el) {
        if (!el.innerHTML.trim() && typeof el.loadRecommendations === 'function' && el.dataset.productId) {
          el.loadRecommendations(el.dataset.productId);
        }
      });
    }, 2500);
  });
})();
